module.exports = __webpack_public_path__ + "img/vehicle-slides-backdrop-mitsu.6a39bf22.png";